
<template>
  <v-container>
    <div class="headline mb-5">Exportação de dados financeiros</div>
    <v-row>
      <v-col cols="6" v-for="(item, idx) in kinds" :key="item.action">
        <v-card style="border-radius:12px">
          <v-card-title primary-title>
            <div class="title mb-0">{{item.text}}</div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-menu v-model="menu_start[idx]" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="$moment(item.start_date).format('DD/MM/YYYY')" label="Início" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker locale="pt-br" v-model="item.start_date" @input="menu_start[idx] = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu v-model="menu_end[idx]" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="$moment(item.end_date).format('DD/MM/YYYY')" label="Início" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker locale="pt-br" v-model="item.end_date" @input="menu_end[idx] = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <div v-if="item.action == 'Sellings'">
              <v-checkbox
                class="my-n4 mt-n1"
                v-model="open_and_overdue"
                :label="`Exportar abertas`"
                @change="() => open_and_overdue ? item.default_filter = {by_status: ['open', 'overdue']} : item.default_filter = {}"
              ></v-checkbox>
            </div>
            <BtnExportCsvAndPDF 
              light-toolbar
              :hide_list="['pdf']"
              :action="item.action" 
              :api_model="item.kind" 
              :filters="{ ...item.default_filter, start_date: item.start_date, end_date: item.end_date }" 
              class="mx-3"
              no_pdf
            ></BtnExportCsvAndPDF>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="loading"
      :persistent="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-alert type="info" :value="true" class="mb-0">
        Buscando dados...
        <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'RenoveExports',
  components: {
    BtnExportCsvAndPDF: () => import('@/components/data_export/BtnCreateDataExport.vue'),
    SelectDepot:() => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
  },
  data() {
    return {
      menu_start: [false, false, false, false],
      menu_end: [false, false, false, false],
      loading: false,
      open_and_overdue: false,
      kinds: [
        {
          text: 'Pagamentos',
          kind: 'Financial',
          action: 'Payments',
          start_date: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end_date: this.$moment().endOf('month').format('YYYY-MM-DD'),
          default_filter: {},
        },
        {
          text: 'Faturas',
          kind: 'Financial',
          action: 'Sellings',
          start_date: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end_date: this.$moment().endOf('month').format('YYYY-MM-DD'),
          default_filter: {},
        },
        {
          text: 'Contas a Pagar / Notas Fornecedores',
          kind: 'Financial',
          action: 'SupplierNotes',
          start_date: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end_date: this.$moment().endOf('month').format('YYYY-MM-DD'),
          default_filter: {},
        }
      ]
      
    }
  },
}
</script>